import { render, staticRenderFns } from "./Courier.vue?vue&type=template&id=1b28882c"
import script from "./Courier.vue?vue&type=script&lang=js"
export * from "./Courier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports